import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { connect } from "react-redux";
import Grid from '@mui/material/Grid';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import EnumComponent from "../components/EnumComponent";
import LoaderComponent from "../components/LoaderComponent";
import { loadEnumsList } from "../api/enumsapi";
import { getEnumsList, getEnumsLoading } from "../selector/selectors";
import { Link } from "react-router-dom";


function ManageEnum({
  isLoading,
  enumsList,
  startLoadingEnums,
}) {

    const [page, setPage]   = React.useState(0);
    const [value, setValue] = React.useState('1');
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    useEffect(() => {
      startLoadingEnums();
    }, [startLoadingEnums]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
        startLoadingEnums(pageVal,rowsPerPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        startLoadingEnums(0,event.target.value);
    }

    return (
        <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
            <Grid container >
                <TabContext value={value}>
                    <Grid item xs={12} md={12} lg={12} >
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="">
                                <Link className="tabingLinks" to="/web/units">Units</Link>
                                <Tab label="Enum" value="1" />
                                <Link className="tabingLinks" to="/web/enum-groups">Enum Groups</Link>
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{p:0,pt:2}}>
                            <Grid container sx={{paddingBottom:2, display: 'flex', justifyContent: 'flex-end'}}>
                               
                            </Grid>
                            <EnumComponent filesList={enumsList} page={page} rowsPerPage={rowsPerPage} handleChangeRowsPerPage={handleChangeRowsPerPage} handleChangePage={handleChangePage} />
                        </TabPanel>
                    </Grid>
                </TabContext>
                {/* <InterpretationFileModal
                    open={unitsAndEnumsDialogBoxStatus || false}
                    value={interpretationFormData}
                    setInterpretationFormData={setInterpretationFormData}
                    interpretationFile={interpretationFile}
                    setInterpretationFile={setInterpretationFile}
                    handleFormData={handleFormData}
                /> */}
            </Grid>
        </Box>
    );
}

const mapStateToProps = (state) => ({
  isLoading: getEnumsLoading(state),  
  enumsList:getEnumsList(state),  
});

const mapDispatchToProps = (dispatch) => ({
    startLoadingEnums: (page,rowsPerPage) => dispatch(loadEnumsList(page,rowsPerPage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageEnum);

